const DEFAULT_STORAGE_KEY = 'api_errors';
/** Browser localStorage adapter; inject into createErrorHandler from app layer. */
export function createBrowserErrorStorage(storageKey = DEFAULT_STORAGE_KEY) {
    return {
        persist(apiError, maxStoredErrors) {
            try {
                const stored = localStorage.getItem(storageKey) ?? '[]';
                const errors = JSON.parse(stored);
                errors.push(apiError);
                if (errors.length > maxStoredErrors) {
                    errors.splice(0, errors.length - maxStoredErrors);
                }
                localStorage.setItem(storageKey, JSON.stringify(errors));
            }
            catch (error) {
                console.warn('Failed to persist API error to localStorage:', error);
            }
        },
        getStored() {
            try {
                const stored = localStorage.getItem(storageKey) ?? '[]';
                return JSON.parse(stored);
            }
            catch {
                return [];
            }
        },
        clear() {
            localStorage.removeItem(storageKey);
        },
    };
}
